var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterialSection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 129,
    viewBox: "0 0 118 129",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.922 33.8911H91.633C87.3107 33.8911 83.8318 30.4122 83.8318 26.09V8.80109C83.8318 4.47886 87.3107 1 91.633 1H108.922C113.244 1 116.723 4.47886 116.723 8.80109V26.09C116.723 30.4122 113.244 33.8911 108.922 33.8911Z",
    fill: "#4796FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.691 17.4456L98.4861 21.2407L106.076 13.6505",
    stroke: "white",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8067 74.2674H50.5177C46.1955 74.2674 42.7166 70.7885 42.7166 66.4662V49.1773C42.7166 44.8551 46.1955 41.3762 50.5177 41.3762H67.8067C72.1289 41.3762 75.6077 44.8551 75.6077 49.1773V66.4662C75.6077 70.7885 72.1289 74.2674 67.8067 74.2674Z",
    fill: "#4796FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4686 57.8214L57.2637 61.6166L64.8539 54.0263",
    stroke: "white",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6932 74.2672H9.40427C5.08204 74.2672 1.60315 70.7884 1.60315 66.4661V49.1772C1.60315 44.855 5.08204 41.3761 9.40427 41.3761H26.6932C31.0155 41.3761 34.4943 44.855 34.4943 49.1772V66.4661C34.4943 70.7884 31.0155 74.2672 26.6932 74.2672Z",
    fill: "#4796FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3553 57.8215L16.1505 61.6166L23.7407 54.0264",
    stroke: "white",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4764 41.3761H26.6932C31.0155 41.3761 34.4943 44.855 34.4943 49.1772V66.4661C34.4943 70.7884 31.0155 74.2672 26.6932 74.2672H9.40427C5.08204 74.2672 1.60315 70.7884 1.60315 66.4661V49.1772C1.60315 44.855 5.08204 41.3761 9.40427 41.3761H13.6211",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.809 74.2672H109.025C113.348 74.2672 116.826 70.7884 116.826 66.4661V49.1772C116.826 44.855 113.348 41.3761 109.025 41.3761H91.7364C87.4141 41.3761 83.9353 44.855 83.9353 49.1772V66.4661C83.9353 70.7884 87.4141 74.2672 91.7364 74.2672H95.9532",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5899 74.2674H67.8067C72.1289 74.2674 75.6077 70.7885 75.6077 66.4662V49.1773C75.6077 44.8551 72.1289 41.3762 67.8067 41.3762H50.5177C46.1955 41.3762 42.7166 44.8551 42.7166 49.1773V66.4662C42.7166 70.7885 46.1955 74.2674 50.5177 74.2674H54.7345",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3058 78.2734C82.7757 78.168 80.7727 80.171 80.7727 82.7011V78.168C80.7727 75.7433 78.8751 73.7404 76.5559 73.6349C74.0258 73.5295 72.0228 75.5325 72.0228 78.0626V73.7404C72.0228 71.3157 70.1253 69.3127 67.806 69.2073C65.276 69.1019 63.2729 71.1049 63.2729 73.6349V58.7707C63.2729 56.346 61.3754 54.343 59.0561 54.2376C56.526 54.1322 54.523 56.1352 54.523 58.6653V85.1257C54.523 82.7011 52.5201 80.6981 50.0954 80.6981C48.8303 80.6981 47.7761 81.2252 46.9328 81.9631C46.0894 82.8065 45.6678 83.8607 45.6678 85.1257V91.9781V99.6737V107.264C45.6678 108.74 46.0895 110.11 47.0382 111.27L51.0442 116.541C51.8876 117.701 52.4146 119.071 52.4146 120.547V127.61H87.7304V120.547C87.7304 119.071 87.9413 117.701 88.2575 116.225L89.4172 111.586C89.7334 110.216 89.9443 108.74 89.9443 107.264V82.8065C89.5226 80.3818 87.7304 78.3788 85.3058 78.2734Z",
    fill: "url(#paint0_linear_6619_1858)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 33.8911H9.40446C5.08223 33.8911 1.60333 30.4122 1.60333 26.09V8.80109C1.60333 4.47886 5.08223 1 9.40446 1H26.6934C31.0156 1 34.4945 4.47886 34.4945 8.80109V26.09C34.4945 30.4122 31.0156 33.8911 26.6934 33.8911Z",
    fill: "#4796FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3514 99.6735V107.264C45.3514 108.74 45.7731 110.11 46.7219 111.27L50.7279 116.541C51.5712 117.7 52.0983 119.071 52.0983 120.547V127.61H87.4141V120.547C87.4141 119.071 87.6249 117.7 87.9412 116.224L89.1008 111.586C89.417 110.216 89.6279 108.74 89.6279 107.264V82.8063C89.6279 80.3816 87.7303 78.3786 85.4111 78.2732C82.881 78.1678 80.878 80.1708 80.878 82.7008V78.1678C80.878 75.7431 78.9805 73.7401 76.6612 73.6347C74.1311 73.5293 72.1281 75.5323 72.1281 78.0623V73.7401C72.1281 71.3155 70.2306 69.3125 67.9113 69.207C65.3813 69.1016 63.3783 71.1046 63.3783 73.6347V58.7704C63.3783 56.3458 61.4807 54.3428 59.1615 54.2374C56.6314 54.132 54.6284 56.1349 54.6284 58.665V85.1255C54.6284 82.7008 52.6254 80.6978 50.2007 80.6978C48.9357 80.6978 47.8815 81.2249 47.0381 81.9629C46.1948 82.8062 45.7731 83.8604 45.7731 85.1255V91.9778",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0643 73.6345V91.7668",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9178 78.0625V91.7671",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6658 82.4897V91.7667",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2063 85.1255V96.4055L52.9412 97.6705",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3553 17.4455L16.1505 21.2406L23.7407 13.6504",
    stroke: "white",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4766 1H26.6934C31.0156 1 34.4945 4.47886 34.4945 8.80109V26.09C34.4945 30.4122 31.0156 33.8911 26.6934 33.8911H9.40446C5.08223 33.8911 1.60333 30.4122 1.60333 26.09V8.80109C1.60333 4.47886 5.08223 1 9.40446 1H13.6213",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8067 33.8911H50.5177C46.1955 33.8911 42.7166 30.4122 42.7166 26.09V8.80109C42.7166 4.47886 46.1955 1 50.5177 1H67.8067C72.1289 1 75.6077 4.47886 75.6077 8.80109V26.09C75.6077 30.4122 72.1289 33.8911 67.8067 33.8911Z",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.809 33.8911H109.025C113.348 33.8911 116.826 30.4122 116.826 26.09V8.80109C116.826 4.47886 113.348 1 109.025 1H91.7364C87.4141 1 83.9353 4.47886 83.9353 8.80109V26.09C83.9353 30.4122 87.4141 33.8911 91.7364 33.8911H95.9532",
    stroke: "#0069FF",
    strokeWidth: 1.80722,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6619_1858",
    x1: 46.0157,
    y1: 64.3092,
    x2: 85.9697,
    y2: 129.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DBEFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSection);
export default __webpack_public_path__ + "static/media/material-section.08eb84e14749508625b594a383b1f082.svg";
export { ForwardRef as ReactComponent };